import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchDisconnectionReportThunk = createAsyncThunk(
  "disconnectionReport/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        from_date: filters?.from_date || "",
        to_date: filters?.to_date || "",
        ward_id: filters?.ward_id || "",
        min_balance: filters?.min_balance ?? 500, // default 500
      };

      const res = await api.get("/api/reports/disconnection-report", { params });

      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed to load report");
      }
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

const disconnectionReportSlice = createSlice({
  name: "disconnectionReport",
  initialState: {
    rows: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearDisconnectionReport: (state) => {
      state.rows = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDisconnectionReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisconnectionReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
      })
      .addCase(fetchDisconnectionReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load report";
      });
  },
});

export const { clearDisconnectionReport } = disconnectionReportSlice.actions;
export default disconnectionReportSlice.reducer;
